import script from "./DissmissalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DissmissalModal.vue?vue&type=script&setup=true&lang=js"

import "./DissmissalModal.vue?vue&type=style&index=0&id=30bc7666&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30bc7666"]])

export default __exports__